import React from "react";
import iphoneIcon from "../../../assets/icon-iphone.svg";

import "./styles.css";

export const IconIphone = () => {
  return <img className="icon-iphone" src={iphoneIcon} alt="email-icon" />;
};
